import React, { FC, memo } from 'react';

import AdminSingleFieldTab from './AdminSingleFieldTab';

const Problem: FC = () => (
  <AdminSingleFieldTab
    fieldName="situation_description"
    commentFieldName="comment_situation_description"
    noteId="expert-note-situation"
    titleKey="tab_situation"
    hintKey="tab_situation_hint"
  />
);

export default memo(Problem);
